export enum SsoOption {
  SSO_AUTH = 'SSO_AUTH',
  BASIC_AUTH = 'BASIC_AUTH',
}
